var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_3513)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_3513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_3513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02498 21.225L7.34998 18.425L4.17498 17.725L4.49998 14.45L2.34998 12L4.49998 9.55002L4.17498 6.27502L7.34998 5.57502L9.02498 2.77502L12 4.02502L14.975 2.77502L16.65 5.57502L19.825 6.27502L19.5 9.55002L21.65 12L19.5 14.45L19.825 17.725L16.65 18.425L14.975 21.225L12 19.975L9.02498 21.225ZM9.44998 19.95L12 18.9L14.55 19.95L16 17.55L18.75 16.95L18.5 14.1L20.35 12L18.5 9.90002L18.75 7.05002L16 6.45002L14.55 4.05002L12 5.10002L9.44998 4.05002L7.99998 6.45002L5.24998 7.05002L5.49998 9.90002L3.64998 12L5.49998 14.1L5.24998 16.95L7.99998 17.55L9.44998 19.95ZM10.95 14.85L15.9 9.90002L15.2 9.17502L10.95 13.425L8.79998 11.3L8.09998 12L10.95 14.85Z",
    fill: "#4B4566"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_3513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessRole);
export default __webpack_public_path__ + "static/media/process-role.2a0e9487646d4fb3d2fd692b978cd9fc.svg";
export { ForwardRef as ReactComponent };